import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute } from "@angular/router";
import { Location } from "@angular/common";

import { FireDataService } from '../fire-data.service';



@Component({
  selector: 'app-user-auth',
  templateUrl: './user-auth.component.html',
  styleUrls: ['./user-auth.component.css']
})
export class UserAuthComponent implements OnInit {

  user = {};
  noEmail = true;
  account = false;
  allowedDomain = ['alycante.it', 'liceoguggenheim.gov.it'];
  invalidDomain: boolean;
  invalidDomainMsg = 'Please sign in with a valid email !!!';


  constructor(private fds: FireDataService, private router: Router, private route: ActivatedRoute, private location: Location) {
     //this.isLogged() ;
  } 

  ngOnInit(): void {
    
    //console.log("Account param OnInit..." )
    this.route.params.subscribe(params => {
      //console.log("Account param...", params["account"] )
        this.account = params["account"];
       if (!this.account) {this.noEmail = false;}
    });
    this.isLogged() ;
  }

  login() {
    var pp = this;
    this.account = false;
    this.fds.login()
            .then(function(){
                this.isLogged();
                
            })
            .catch (function(err){
                pp.user['msg'] = 'wait for login...'
            });
  }

  logout() {
    this.fds.logout();
    this.noEmail = true;
  }

    isLogged() {
        this.fds.user.subscribe(res => {
        if (res) {
        var b = res.email.split('@')
        if (!this.validateDomain(b[1], this.allowedDomain)) {
          this.account = false;
          this.logout();
          this.invalidDomain = true; 
          this.user['msg'] = this.invalidDomainMsg;
          return
        }
       this.user = res, this.noEmail = false;
       //console.log("account ...:", this.account, b[1])
       if (!this.account) {this.router.navigate(["/home"])}
        }
        if (!res) {
        this.user['msg'] = 'NOT LOGGED', this.noEmail = true, this.account = false;
        if (this.invalidDomain) {this.user['msg'] = this.invalidDomainMsg}
        }
    });
  }

  private validateDomain(domain, arrayDomain) {

    if (arrayDomain.findIndex(isInArray) == -1) {return false}  //domain not allowd
        else {return true}

    function isInArray(element) {
        return element == domain;
    }

  }

  public goBack() {
    this.location.back();

  }


}



// WEBPACK FOOTER //
// c:/Dev/Angular/liceo/src/app/user-auth/user-auth.component.ts